import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MainGrid = styled(Grid)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 10px;
  border: 2px solid #eeeeee;
  padding: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  box-sizing: border-box;
`;

export const ButtonsWrapper = styled(Grid)`
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 20px;
  margin-right: 20px;
  padding-bottom: 20px;
`;